import { connect } from 'react-redux'
import General from './general'
import {
  getUser,
  getUpdateAccountRequest
} from '../../../../stores/user/user.selectors'
import { updateUser } from '../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  const updateAccountDetails = getUpdateAccountRequest(state)
  return {
    pending: updateAccountDetails.pending,
    firstName: user.first_name,
    lastName: user.last_name,
    displayName: user.display_name
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    const data = {
      first_name: values.firstName,
      last_name: values.lastName,
      display_name: values.displayName
    }
    dispatch(updateUser(data))
      .then(() => toast.success('Your details were successfully updated.'))
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(General)
